export const RenderService = Symbol.for("RenderService");

export const BeforeRenderConstribution = Symbol.for("BeforeRenderConstribution");
//# sourceMappingURL=constants.js.map
